import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CrudService } from '../crud.service';
import { Bookmark } from '../../models/bookmark';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BookmarkService extends CrudService<Bookmark> {
  protected basePath = 'bookmark'; // Specific for BookmarkService
  public instanceType = 'bookmark'; // Used in base service for constructing URLs

  constructor(http: HttpClient) {
    super(http);
  }

  async getByCategoryIds(categoryIds: string[]) {
    const headers = new HttpHeaders({
      'X-Category-Ids': JSON.stringify(categoryIds),
    });
    return await lastValueFrom(
      this.http.get<{ [key: string]: Bookmark }>(
        `${this.getBaseUrl()}/categories`,
        { headers: headers }
      )
    );
  }
}
